import React, { useState } from "react";
import { Button, Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import routes from "../../lib/routes";
import { useCurrentUser } from "../../lib/hooks";
import styles from "./MarketingWidget.module.css";

interface MarketingWidgetProps {
  featureKey: "machinery" | "invoices" | "purchases" | "harvest";
  children: React.ReactElement;
  title: React.ReactNode;
  description: React.ReactNode;
}

const MODULE_ROUTES = {
  machinery: routes.machines.index,
  purchases: routes.inventory.purchases.index,
  invoices: routes.finance.index,
  harvest: routes.agro.harvestEstimates.index,
};

export function MarketingWidget({
  featureKey,
  children,
  title,
  description,
}: MarketingWidgetProps) {
  const { currentTenant } = useCurrentUser();
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  if (currentTenant.planName !== "free") {
    return children || null;
  }

  const handleClick = (e: React.MouseEvent) => {
    if (!isHovered) {
      e.stopPropagation();
      setIsClicked(!isClicked);
    }
  };

  const showOverlay = isHovered || isClicked;

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      {!showOverlay && (
        <Button type="primary" className={styles.badge}>
          <FormattedMessage id="upgrade" defaultMessage="Upgrade" />
        </Button>
      )}
      {children}
      {showOverlay && (
        <div className={styles.overlay}>
          <Space
            orientation="vertical"
            align="center"
            size="middle"
            className={styles.content}
          >
            <Typography.Title level={5} style={{ margin: 0 }}>
              {title}
            </Typography.Title>
            <Typography.Text>{description}</Typography.Text>
            <Button type="primary">
              <Link href={MODULE_ROUTES[featureKey]}>
                <FormattedMessage
                  id="subscriptions.upgrade"
                  defaultMessage="Update plan"
                />
              </Link>
            </Button>
          </Space>
        </div>
      )}
    </div>
  );
}
